import axios, { AxiosInstance, AxiosRequestConfig } from "axios";

export class HttpService {
  private $http: AxiosInstance;
  private path: string;

  constructor(path = "/journal") {
    this.$http = axios.create({
      baseURL: "https://www.nikaple.com/api",
      method: "GET",
      timeout: 30000
    });
    this.path = path;
  }

  /**
   * get request
   * 
   * @param {AxiosRequestConfig} [opt] 
   * @returns 
   * @memberof HttpService
   */
  public get(opt?: AxiosRequestConfig) {
    return this.$http.get(this.path, opt);
  }

  /**
   * post request
   * 
   * @param {*} data 
   * @param {AxiosRequestConfig} [opt] 
   * @returns 
   * @memberof HttpService
   */
  public post(data: any, opt?: AxiosRequestConfig) {
    return this.$http.post(this.path, data, opt);
  }
}



// WEBPACK FOOTER //
// ../~/tslint-loader!./scripts/services/http-service.ts